import * as React from 'react';
import { DetailListActions, DropdownActionConfig } from 'Components/General/DetailListActions';
import { EmailUploadFile } from '../Stores/EmailSubmitStore';
import { withModal, WithModal } from 'Components/General/Modal/withModal';
import { withTranslation, WithTranslation } from 'react-i18next';
import { I18N_NS } from 'Config/i18n';
import { IconProp } from '@fortawesome/fontawesome-svg-core';

interface EmailAttachmentsTableActionsProps extends WithTranslation, WithModal {
  files: Array<EmailUploadFile | API_FileDataEntity>;
  disabledDownload: boolean;
  resetSelection: () => void;
  onRemoveSelectedFiles: () => void;
  onDownload: () => void;
}

export const EmailAttachmentsTableActions = withModal(withTranslation(I18N_NS.PROJECT)(
  class extends React.Component<EmailAttachmentsTableActionsProps> {
    get dropdownActions(): DropdownActionConfig[] {
      const { t, onDownload, disabledDownload } = this.props;
      const config = [
        {
          label: t('Remove'),
          onClick: () => this.props.onRemoveSelectedFiles(),
          icon: ['far', 'trash-alt'] as IconProp,
          disabled: false,
        },
        {
          label: t('Download'),
          onClick: onDownload,
          disabled: disabledDownload,
          icon: ['far', 'download'] as IconProp
        }
      ];

      return config;
    }
    render() {
      return (
        <DetailListActions
          primaryActions={[]}
          dropdownActions={this.dropdownActions}
        />
      );
    }
  }
));